import React, { useContext, useState } from "react"
import { Alert, Button } from "reactstrap"
import PropTypes from "prop-types"
import { analysisContext } from "context/analysis-context"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { extractDocument, updateDocument } from "api/docApi"
import LoadingButton from "components/Common/LoadingButton"
import { t } from "i18next"
import { extractedFields } from "helpers/utils"
import ExtractedField from "./ExtractedField"
import EditFieldsForm from "./EditFieldsForm"
import { toast } from "react-toastify"
import lodash from "lodash"

function ExtractedFieldList({ document = {} }) {
  const { id, extracted_data } = document
  const { slideIndex } = useContext(analysisContext)
  const [isEdit, setIsEdit] = useState(false)
  const queryClient = useQueryClient()

  const extractDocMutation = useMutation({
    mutationFn: () => extractDocument(id),
  })

  const updateDocMutation = useMutation({
    mutationFn: values => {
      const rollbackFields = extracted_data.fields
      const payload = {
        extracted_data: {
          fields: { ...rollbackFields, [slideIndex]: values.fields },
        },
      }
      return updateDocument(id, payload)
    },
    onSuccess: data => {
      queryClient.invalidateQueries("documents")
      setIsEdit(false)
    },
    onError: error => toast.error(error),
  })

  const fields = extractedFields(extracted_data, slideIndex)

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">{t("extracted data")}</h5>
        <LoadingButton
          isLoading={extractDocMutation.isPending}
          onClick={extractDocMutation.mutate}
          color="primary"
          size="sm"
        >
          {t("extract")}
        </LoadingButton>
      </div>

      {isEdit ? (
        <EditFieldsForm fields={fields} onSubmit={updateDocMutation.mutate} />
      ) : null}

      {!lodash.isEmpty(fields) && !isEdit ? (
        <>
          <div className="fields overflow-auto">
            {fields.map(field => {
              return <ExtractedField key={field.id} fieldData={field} />
            })}
          </div>
          <Button onClick={() => setIsEdit(true)}>{t("edit")}</Button>
        </>
      ) : null}

      {lodash.isEmpty(fields) ? (
        <Alert color="warning">{t("no fields")}</Alert>
      ) : null}
    </div>
  )
}

ExtractedFieldList.propTypes = {
  document: PropTypes.object,
}

export default ExtractedFieldList
